import type { ReactNode } from "react";
import type {
  AdvancedEditableTableCellFieldDefinition,
  AdvancedEditableTableFieldDefinition,
} from "models/propTypes/wintFormPropsTypes";

// Row-dependent extra props have no single label to show above the column.
export const getColumnHeader = <T>(field?: AdvancedEditableTableCellFieldDefinition<T>): ReactNode => {
  if (!field) return "";
  if (field.header !== undefined) return field.header;
  if (typeof field.extraProps === "function") return "";
  return field.extraProps?.headerLabel || field.extraProps?.label || "";
};

/** Where the footer row starts; undefined when no column has a footer. */
export const getFooterLayout = <T>(fields: AdvancedEditableTableFieldDefinition<T>, showRowIndexes?: boolean) => {
  const keys = Object.keys(fields) as (keyof T)[];
  const firstFooterIndex = keys.findIndex((key) => fields[key]?.footer !== undefined);
  if (firstFooterIndex === -1) return undefined;
  return { labelColSpan: firstFooterIndex + (showRowIndexes ? 1 : 0), footerKeys: keys.slice(firstFooterIndex) };
};
